import { AppHeader } from "@/components/layout";
import { Card, Skeleton } from "@/components/ui";
import { PostCardSkeleton } from "@/components/social";

function RailSkeleton() {
  return (
    <Card className="space-y-4">
      <Skeleton className="h-5 w-32" />
      {Array.from({ length: 4 }, (_, index) => (
        <div key={index} className="space-y-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-3 w-20" />
        </div>
      ))}
    </Card>
  );
}

export function FeedPageSkeleton() {
  return (
    <>
      <AppHeader />
      <div
        className="mx-auto grid max-w-(--breakpoint-xl) grid-cols-1 gap-8 px-6 py-6 xl:grid-cols-[minmax(0,600px)_320px]"
      >
        <main className="min-w-0 space-y-4">
          <h1 className="sr-only">Feed</h1>
          <Card className="h-28">
            <Skeleton className="h-full w-full" />
          </Card>
          <div className="flex gap-6 border-b border-border pb-3">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-20" />
          </div>
          <PostCardSkeleton variant="media" />
          <PostCardSkeleton />
          <PostCardSkeleton variant="media" />
        </main>
        <aside className="hidden space-y-4 xl:block">
          <RailSkeleton />
          <RailSkeleton />
        </aside>
      </div>
    </>
  );
}
